export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: that.$l('INDEX.table_label_opt') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: { default: 'opt' },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_versionNo') || '版本编号',
    field: 'versionNo',
    align: 'left',
    headerAlign: 'center',
    width: 150,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_versionName') || '版本名称',
    field: 'versionName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_releaseDate') || '发布日期',
    field: 'releaseDate',
    align: 'left',
    headerAlign: 'center',
    width: 140,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_updateContent') || '版本更新内容',
    field: 'updateContent',
    align: 'left',
    headerAlign: 'center',
    minWidth: 200,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_displayStatus') || '版本状态',
    field: 'displayStatus',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    slots: { default: 'displayStatus' },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_fileSize') || '应用大小(MB)',
    field: 'fileSize',
    align: 'center',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_downloadUrl') || '应用下载链接',
    field: 'downloadUrl',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_forceUpdate') || '是否强制更新',
    field: 'forceUpdate',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    slots: { default: 'forceUpdate' },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_platform') || '适用的平台',
    field: 'platform',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_remarks') || '备注',
    field: 'remarks',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    align: 'left',
    headerAlign: 'center',
    width: 170,
    slots: { default: 'displayCreate' },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    align: 'left',
    headerAlign: 'center',
    width: 170,
    slots: { default: 'displayModify' },
    showHeaderOverflow: true
  }
]
